import { Button, Grid, Paper, Tooltip, Typography } from "@material-ui/core";
import React, { useEffect } from "react";
import { thorEventStyles } from "./ThorEventStyles";
import moment from "moment";
import { ThorEventProps } from "./ThorEventProps";
import { useHistory } from "react-router-dom";
import { useStore } from "store/StoreConfigs";
import { ReactComponent as PriorityFlag } from "icons/PriorityFlag.svg";
import { ReactComponent as AssignPlus } from "icons/AssignPlus.svg";
import { ReactComponent as QA } from "icons/QA.svg";
import { ReactComponent as ReviewerQA } from "icons/ReviewerQA.svg";
import { EventStatus } from "models/thorEventModels/EventDetails";

export default function ThorEvent({ events }: ThorEventProps) {
    const classes = thorEventStyles();
    const history = useHistory();
    const { thorEventViewStore } = useStore();

    useEffect(() => {
        thorEventViewStore.setSelectedBatch(0);
    }, []);

    return (
        <>
            {events.map((event) => (
                <div key={event.eventId}>
                    <Grid item xs={12} className={classes.grid}>
                        <Paper elevation={0} className={classes.main}>
                            <Grid container justifyContent="space-between">
                                <Grid item className={classes.gridItem}>
                                    {event.eventType}
                                </Grid>
                                <Grid item className={classes.gridItem}>
                                    {"TE" + event.eventId}
                                </Grid>
                                <Grid item className={classes.gridItem}>
                                    {moment.utc(event.eventDate).format("MM/DD/YY")}{" "}
                                    <span className={classes.subText}>
                                        {moment.utc(event.eventDate).format("HH:mm:ss")}
                                    </span>
                                </Grid>
                                <Grid item className={classes.gridItem}>
                                    {event.impactedDeliveries.map((x) => x.deliveryNumber).join(",")}
                                </Grid>
                                <Grid item className={classes.gridItem}>
                                    {event.eventStatusId === EventStatus.New ? (
                                        <span className={classes.new}>New Event</span>
                                    ) : event.eventStatusId === EventStatus.Closed ? (
                                        <span className={classes.completeText}>Evaluation Complete</span>
                                    ) : (
                                        <span className={classes.pendingText}>
                                            {event.eventStatusId === EventStatus.PendingReview
                                                ? "Pending Review"
                                                : event.eventStatusId === EventStatus.PendingApproval
                                                ? "Pending Approval"
                                                : event.eventStatusId === EventStatus.ReOpened
                                                ? "Re-Opened"
                                                : null}
                                        </span>
                                    )}
                                </Grid>
                                <Grid item className={classes.gridItem}>
                                    <span className={classes.iconContainer}>
                                        <span className={classes.iconSpacing}>
                                            {event.priority === "Medium" ? (
                                                <PriorityFlag style={{ fill: "#FFAB00" }} />
                                            ) : event.priority === "High" ? (
                                                <PriorityFlag style={{ fill: "#DF5031" }} />
                                            ) : event.priority === "Low" ? (
                                                <PriorityFlag style={{ fill: "#00AF41" }} />
                                            ) : null}
                                        </span>
                                        {event.priority}
                                    </span>
                                </Grid>
                                <Grid item className={classes.gridItem}>
                                    {event.reviewerUserId || event.qaUserId ? (
                                        event.reviewerUserId && event.qaUserId ? (
                                            <Tooltip
                                                classes={{ tooltip: classes.tooltip }}
                                                placement="top"
                                                title={
                                                    <React.Fragment>
                                                        <div style={{ padding: "10px" }}>
                                                            <Typography>Reviewer: {event.reviewerUserId}</Typography>
                                                            <br />
                                                            <Typography>QA: {event.qaUserId}</Typography>
                                                        </div>
                                                    </React.Fragment>
                                                }
                                            >
                                                <ReviewerQA className={classes.image} />
                                            </Tooltip>
                                        ) : (
                                            <Tooltip
                                                classes={{ tooltip: classes.tooltip }}
                                                placement="top"
                                                title={
                                                    <React.Fragment>
                                                        <div style={{ padding: "10px" }}>
                                                            <Typography>Reviewer: {event.reviewerUserId}</Typography>
                                                        </div>
                                                    </React.Fragment>
                                                }
                                            >
                                                <QA className={classes.image} />
                                            </Tooltip>
                                        )
                                    ) : (
                                        <AssignPlus
                                            onClick={() => {
                                                event.handleAssignData({
                                                    eventId: event.eventId,
                                                    reviewerUserId: event.reviewerUserId,
                                                    qaUserId: event.qaUserId,
                                                    eventStatusId: event.eventStatusId,
                                                });
                                                thorEventViewStore.setAssignMenuOpen(true);
                                            }}
                                            className={classes.image}
                                        />
                                    )}
                                </Grid>
                                <Grid item className={classes.gridItem + " " + classes.additionalBtnStyles}>
                                    <Button
                                        onClick={() => {
                                            history.push(`thor/eventDetails/${event.eventId}`);
                                        }}
                                        className={classes.detailsBtn}
                                    >
                                        View Details
                                    </Button>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </div>
            ))}
        </>
    );
}
